<script setup lang="ts">
  import { computed } from 'vue'
  import { randomId } from '@/functions'

  const props = defineProps<{
    submitting: boolean,
    disabled?: boolean,
    id?: string,
  }>()

  const emit = defineEmits<{
    (e: 'submit'): void,
    (e: 'cancel'): void,
  }>()

  const defaultFormId = randomId()
  const formId = computed(() => props.id ?? defaultFormId)
</script>

<template>
  <form
    :id="formId"
    @submit.prevent="emit('submit')">
    <slot></slot>

    <slot name="action">
      <div class="flex-center space-x-4 lg:justify-start lg:pl-52 xl:pl-68">
        <app-button
          class="btn-gray-outline w-32"
          :disabled="submitting"
          @click="emit('cancel')">
          Batal
        </app-button>
        <app-submit
          class="w-32 btn-primary"
          :disabled="disabled"
          :loading="submitting">
          Simpan
        </app-submit>
      </div>
    </slot>
  </form>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  :deep(section) {
    @apply mb-8 border-b pb-8;
  }
</style>
